<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-lg-12 col-sm-12">
          <div class="element-box mb-0">
            <form  @submit="refresh">
                <h5 class="form-header">
                PARTICIPACION CATEGORIA
                </h5>
                <div class="col-md-6">
                  <TiendaSelectComponent :current="current" />
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                      <label
                            v-bind:class="{
                            'text-danger':
                            current.errors.sub_categoria &&
                            current.errors.sub_categoria.length > 0,
                            }"
                        >
                            SubCategoria
                        </label>
                        <select
                            class="form-control"
                            autofocus="autofocus"
                            v-model="current.sub_categoria"
                            @input="$emit('input', $event.target.value)"
                        >
                            <option
                                v-for="(c, key) in subcategorias"
                                :value="c.codigo"
                                :key="key"
                            >
                                {{ c.nombre }}
                            </option>
                        </select>
                        <small
                            v-if="current.errors && current.errors.sub_categoria"
                            class="form-text text-danger"
                        >
                            {{ current.errors.sub_categoria[0] }}
                        </small>
                    </div>
                </div>
                <div class="form-buttons-w">
                    <button class="btn btn-md btn-success" type="submit">Refrescar</button>
                </div>
            </form>
          </div>
        </div>
  
      </div>

      
    </div>
    <div class="row">
        <div class="col-md-12">
          <div class="element-wrapper">
            <div class="element-box">
              <br />
              <button
                v-if="datos"
                @click="GenerarReporte(current)"
                class="btn btn-secondary btn-sm btn-block"
              >
                <span>Descargar en PDF</span>
              </button>
              <br />
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th>Sku</th>
                      <th>Descripcion</th>
                      <th>Proveedor</th>
                      <th>Participacion</th>
                      <th>Acumulado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in datos" :key="item.id"
                        v-bind:style= "{color: colorFila(item.Tipo)}"
                        >
                      <td>{{ item.Tipo }}</td>
                      <td>{{ item.producto_id }}</td>
                      <td>{{ item.nombre }}</td>
                      <td>{{ item.proveedor}}</td>
                      <td>{{ item.prct_part | porcentaje(2) }}</td>
                      <td>{{ item.prct_acum | porcentaje(2) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import ReqTrasladoService from "@/services/inventario/ReqTrasladoService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoUnidadMedidaSelectComponent from "@/components/commons/ProductoUnidadMedidaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import DynamicService from "@/services/commons/DynamicService";
import ProductoTiendaTableComponent from "@/components/cat/productos/ProductoTiendaTableComponent";

export default {
  components: {
    TiendaSelectComponent,
    ProductoUnidadMedidaSelectComponent,
    ProductoSelectComponentV2,
    ProductoTiendaTableComponent,
  },
  data() {
    return {
      current: {
        tienda: null,
        fecha_final: null,
        fecha_inicial: null,
        errors: {
          productos: null,
          fecha_inicial: null,
          fecha_final: null,
        },
      },
      datos: [],
         
    }
  },
  
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
      subcategorias: "catalogos/subcategorias"
    }),
    
  },
    
  watch: {
    $route(to, from) {
      if (this.$route.params.tienda) {
        
        this.current.tienda = this.$route.params.tienda;
        this.refresh();
      }
    },
  },
  mounted() {
    let self = this;
    self.$store.dispatch("catalogos/subcategorias", {
    activa: true,
    quitar_paginacion: true,
      });
  },
  filters:{
        porcentaje:function(value,decimals){
            if (!value) {
                value = 0
                }

            if (!decimals) {
                decimals = 0
                }

            value = value * 100
            value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
            value = value + '%'
            return value
        }
  },
  methods: {
    GenerarReporte(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=catalogos/participacion_sku_categoria.jrxml&tienda=${current.tienda}&subcat=${current.sub_categoria}`
      );
      
    },
    colorFila(tipo){
        let color={}
        if (tipo === 'A') {
          color='green';
      } else if (tipo === 'B'){
          color= '#e8c90c';
      } else {
          color= 'red';
      }
      return color
    },
    refresh(e) {
      if (e) {
        e.preventDefault();
      }
      let self = this;
      let params = {};
      if (self.current.tienda) {
        params.tienda = self.current.tienda;
      }
      DynamicService.getAction(
        "cat",
        "subcategoria",
        self.current.sub_categoria,
        "participacion_sku",
        params  
      )
        .then((res) => {
          self.datos = res.data;
          console.log(self.datos)
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },
  },
};
</script>
